module.exports = __webpack_public_path__ + "img/ic_mastercard.2ec172a6.svg";